import { useRef } from 'react'
import { useIntersection } from 'react-use'
import PropTypes from 'prop-types'
import type { Scalars } from '../../generated/graphql'
import useCountdown from '../../hooks/useCountdown'
import styles from './Countdown.module.css'

interface Props {
  time: Scalars['TimeStamp']
  className?: string
  skip?: boolean
  children?: React.ReactNode
}

export default function Countdown({
  time,
  className = '',
  skip = false,
  children,
}: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const observe = useIntersection(ref, { threshold: 0.1 })

  const countdown = useCountdown(time, !observe?.isIntersecting || skip)

  return (
    <div ref={ref}>
      <span className={styles.countdown}>
        {children || `${countdown.label}`}
      </span>
    </div>
  )
}

Countdown.propTypes = {
  time: PropTypes.string,
  className: PropTypes.string,
  skip: PropTypes.bool,
}
